import React from "react";
import Logo from "./Logo.png";

import {Wrap} from "./styles";

export default function Header(props) {
  return (
    <Wrap screen={props.screen} id={props.id} history={props.history}>
      <section onClick={() => props.history.push("/")}>
        <img alt="logo" src={Logo} />
      </section>
      <div>
        {props.firstButton && <button onClick={props.firstButton.action}>{props.firstButton.label}</button>}
        {props.secondButton && <button onClick={props.secondButton.action}>{props.secondButton.label}</button>}
      </div>
    </Wrap>
  );
}
